import { createSlice } from "@reduxjs/toolkit";

export const ScheduleSlice = createSlice({
  name: "Schedule",
  initialState: {
    AuditLogData: [],
    PatientSearchData: [],
    UserSearchData: [],
    PatientSearchNoResult: "1",
    UserSearchNoResult: "1",
    ScheduleLoading: false,
    BillingFacility: "",
    PracticeDashboard: [],
    DelInvData: "",
    TotalCreditAmt: false,
    AddPayment: [],
    PatCreditPay: "",
    showComp: false,
    InvoiceLoading: false,
    DashboardLoading: false,
    saveButton: {
      appointment: false,
      billing: false,
      vitals: false,
    },
    btnDis: false,
    SpinnerVal: true,
    repeats_checked: false,
    callFunction: {
      appointment: 1,
      billing: 1,
      vitals: 1,
    },
    changeFacility: false,
    facilityError: {
      email: false,
      time: false,
    },
    refreshCalender : false
  },
  reducers: {
    GetAuditLogData: (Data) => {
      return Data;
    },
    GetAuditLogDataLoading: (state) => {
      state.ScheduleLoading = true;
    },
    SetAuditLogData: (state, action) => {
      state.AuditLogData = action.payload;
      state.ScheduleLoading = false;
    },
    SetAuditLogTenData(state, action) {
      state.AuditLogData = [...state.AuditLogData, ...action.payload];
    },

    GetPatientSearchData: (Data) => {
      return Data;
    },
    SetPatientSearchData: (state, action) => {
      state.PatientSearchData = action.payload;
      state.ScheduleLoading = false;
    },
    SetPatientSearchNoResult: (state, action) => {
      state.PatientSearchNoResult = action.payload;
      state.PatientSearchData = [];
    },

    GetUserSearchData: (Data) => {
      return Data;
    },
    SetUserSearchData: (state, action) => {
      state.UserSearchData = action.payload;
      state.ScheduleLoading = false;
    },
    SetUserSearchNoResult: (state, action) => {
      state.UserSearchNoResult = action.payload;
      state.UserSearchData = [];
    },
    GetBillingFacility: (Data) => {
      return Data;
    },
    setBillingFacility: (state, action) => {
      state.BillingFacility = action.payload;
    },
    GetPracticeDashboard: (Data) => {
      return Data;
    },
    GetPracticeDashboardLoading: (state) => {
      state.DashboardLoading = true;
    },
    SetPracticeDashboard: (state, action) => {
      state.PracticeDashboard = action.payload;
      state.DashboardLoading = false;
    },
    SetPracticeTenDashboard(state, action) {
      state.PracticeDashboard = [...state.PracticeDashboard, ...action.payload];
    },
    GetDeleteInvoice: (state) => {
      state.InvoiceLoading = true;
    },
    SetDeleteInvoice: (state, action) => {
      state.DelInvData = action.payload;
      state.InvoiceLoading = false;
    },

    GetTotalCreditAmt: (state) => {
      state.InvoiceLoading = true;
    },
    SetTotalCreditAmt: (state, action) => {
      state.TotalCreditAmt = action.payload;
      state.InvoiceLoading = false;
    },

    GetAddPayment: (state) => {
      state.InvoiceLoading = true;
    },
    SetAddPayment: (state, action) => {
      state.AddPayment = action.payload;
      state.InvoiceLoading = false;
    },

    GetPatCreditPay: (state) => {
      state.InvoiceLoading = true;
    },
    SetPatCreditPay: (state, action) => {
      state.PatCreditPay = action.payload;
      state.InvoiceLoading = false;
    },

    SetCompOpen: (state, action) => {
      state.showComp = action.payload;
    },
    changeFacilityError: (state, action) => {
      const { name, value } = action.payload;
      state.facilityError[name] = value;
    },
    changeRefreshRequest :(state, action) => {
      state.refreshCalender = action.payload
    },
    changeAppointmentValues: (state, action) => {
      let data = action.payload;
      if (data.name === "save button") {
        state.saveButton[data.value] = true;
      } else if (data.name === "disable") {
        state.btnDis = data.value;
      } else if (data.name === "spinner") {
        state.SpinnerVal = data.value;
      } else if (data.name === "repeats checked") {
        state.repeats_checked = data.value;
      } else if (data.name === "call function") {
        state.callFunction[data.value] = state.callFunction[data.value] + 1;
      } else if (data.name === "reset") {
        state.callFunction = {
          appointment: 1,
          billing: 1,
          vitals: 1,
        };
        state.saveButton = {
          appointment: false,
          billing: false,
          vitals: false,
        };
      } else if (data.name === "reset call") {
        state.callFunction = {
          appointment: 1,
          billing: 1,
          vitals: 1,
        };
      }
    },
    changeFacilitySelect: (state, action) => {
      state.changeFacility = action.payload;
    },
  },
});

export const {
  GetAuditLogData,
  SetAuditLogData,
  GetAuditLogDataLoading,
  GetPatientSearchData,
  SetPatientSearchData,
  GetUserSearchData,
  SetUserSearchData,
  SetAuditLogTenData,
  SetPatientSearchNoResult,
  SetUserSearchNoResult,
  GetBillingFacility,
  setBillingFacility,
  GetPracticeDashboard,
  GetPracticeDashboardLoading,
  SetPracticeDashboard,
  SetPracticeTenDashboard,
  SetDeleteInvoice,
  GetDeleteInvoice,
  GetTotalCreditAmt,
  SetTotalCreditAmt,
  GetAddPayment,
  SetAddPayment,
  SetCompOpen,
  GetPatCreditPay,
  SetPatCreditPay,
  changeAppointmentValues,
  changeFacilitySelect,
  changeFacilityError,
  changeRefreshRequest
} = ScheduleSlice.actions;

export default ScheduleSlice.reducer;
